import React, { Component } from "react";
import { Page, Grid, Card, Table, Badge, Alert, Dimmer, Form, Button, Icon } from "tabler-react";
import Modal from "react-modal";
import SiteWrapper from "../../SiteWrapper.react";
import { api_raiz } from "../../config/config";

const currentUser = JSON.parse(sessionStorage.getItem("currentUser"));

const styles = {
  searchCard: {
    borderLeft: "4px solid #467fcf",
    marginBottom: 24,
  },
  searchBody: {
    padding: "20px 24px",
  },
  statLabel: {
    fontSize: "0.75rem",
    color: "#9aa0ac",
    textTransform: "uppercase",
    letterSpacing: "0.5px",
    marginBottom: 6,
  },
  statValue: {
    fontSize: "1.4rem",
    fontWeight: 700,
    color: "#495057",
  },
  statCard: {
    marginBottom: 16,
    transition: "box-shadow 0.2s",
    borderRadius: 8,
  },
  jsonPre: {
    background: "#1e1e2e",
    color: "#a6e3a1",
    padding: 20,
    borderRadius: 8,
    overflowX: "auto",
    fontSize: "0.82rem",
    lineHeight: 1.6,
    margin: 0,
    maxHeight: 500,
    border: "1px solid #313244",
  },
  emptyState: {
    textAlign: "center",
    padding: "48px 24px",
    color: "#9aa0ac",
  },
  emptyIcon: {
    fontSize: "3rem",
    marginBottom: 12,
    display: "block",
  },
};

class RetransmisionResponsePage extends Component {
  constructor(props) {
    super(props);
    const params = new URLSearchParams(props.location.search);
    this.state = {
      serviceId: params.get("service_id") || "",
      apiKey: "",
      user: "",
      data: null,
      loading: false,
      error: null,
      showUnits: false,
      showUnitsModal: false,
      unitSearch: "",
      expandedPos: {},
      showNotRegistered: false,
      showRequestPos: false,
    };
    this.fetchData = this.fetchData.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
  }

  componentDidMount() {
    if (this.tieneAcceso() && this.state.apiKey) {
      this.fetchData();
    }
  }

  handleKeyDown(e) {
    if (e.key === "Enter" && this.state.apiKey && this.state.serviceId) {
      this.fetchData();
    }
  }

  fetchData() {
    const { serviceId, apiKey, user } = this.state;
    if (!apiKey) {
      this.setState({ error: "Ingresa el API Key para consultar." });
      return;
    }
    this.setState({ loading: true, error: null });
    let url = `${api_raiz}retxlegacy/api/serviceResponse.php?service_id=${encodeURIComponent(serviceId)}`;
    if (user) url += `&user=${encodeURIComponent(user)}`;
    fetch(url, { headers: { "X-API-Key": apiKey } })
      .then((res) => res.json())
      .then((data) => this.setState({ data, loading: false }))
      .catch((error) => this.setState({ error: error.message, loading: false }));
  }

  formatContent(str) {
    if (!str || !str.trim()) return "—";
    const trimmed = str.trim();
    // Try JSON
    try {
      const parsed = JSON.parse(trimmed);
      return JSON.stringify(parsed, null, 2);
    } catch(e) {}
    // Try XML formatting
    if (trimmed.startsWith("<")) {
      let formatted = "";
      let indent = 0;
      trimmed.replace(/>\s*</g, "><").split(/(<[^>]+>)/g).filter(Boolean).forEach((node) => {
        if (node.match(/^<\/\w/)) indent--;
        formatted += "  ".repeat(Math.max(indent, 0)) + node + "\n";
        if (node.match(/^<\w[^/]*[^/]>$/)) indent++;
      });
      return formatted.trim();
    }
    return trimmed;
  }

  parseMessages(responsePos) {
    try {
      const parsed = JSON.parse(responsePos);
      if (!parsed.idmsg) return [];
      return parsed.idmsg.map((msg) => {
        const msgId  = (msg.match(/Msg Id=(\S+)/)  || [])[1] || "-";
        const idVeh  = (msg.match(/idVeh=(\S+)/)   || [])[1] || "-";
        const tagId  = (msg.match(/tagId=(\S+)/)   || [])[1] || "-";
        const status = msg.includes("Not Found") ? "Not Found" : "OK";
        return { msgId, idVeh, tagId, status, raw: msg };
      });
    } catch (e) {
      return [];
    }
  }

  tieneAcceso() {
    return currentUser && currentUser[0];
  }

  render() {
    if (!this.tieneAcceso()) {
      return (
        <SiteWrapper>
          <Page.Content title="Acceso Denegado">
            <Alert type="danger" icon="alert-triangle">
              No tienes permisos para ver esta página.
            </Alert>
          </Page.Content>
        </SiteWrapper>
      );
    }

    const { data, loading, error, serviceId, apiKey, user } = this.state;

    return (
      <SiteWrapper>
        <Page.Content title="Estatus de Retransmisión">
          {/* Barra de búsqueda */}
          <Card style={styles.searchCard}>
            <Card.Body style={styles.searchBody}>
              <Grid.Row alignItems="center">
                <Grid.Col sm={3}>
                  <Form.Group label={<span><Icon name="hash" /> Service ID</span>}>
                    <Form.Input
                      value={serviceId}
                      onChange={(e) => this.setState({ serviceId: e.target.value })}
                      onKeyDown={this.handleKeyDown}
                      placeholder="Ej: 123"
                    />
                  </Form.Group>
                </Grid.Col>
                <Grid.Col sm={4}>
                  <Form.Group label={<span><Icon name="lock" /> API Key</span>}>
                    <Form.Input
                      type="password"
                      value={apiKey}
                      onChange={(e) => this.setState({ apiKey: e.target.value })}
                      onKeyDown={this.handleKeyDown}
                      placeholder="Ingresa el API Key"
                    />
                  </Form.Group>
                </Grid.Col>
                <Grid.Col sm={4} style={{ display: "flex", alignItems: "flex-end", paddingBottom: 16 }}>
                  <Button
                    color="primary"
                    icon="search"
                    onClick={this.fetchData}
                    disabled={loading || !apiKey || !serviceId}
                    block
                  >
                    {loading ? "Consultando..." : "Consultar Servicio"}
                  </Button>
                </Grid.Col>
              </Grid.Row>
            </Card.Body>
          </Card>

          {error && (
            <Alert type="danger" icon="alert-triangle" isDismissible>
              {error}
            </Alert>
          )}

          <Dimmer active={loading} loader>
            {/* Estado vacío */}
            {!data && !loading && !error && (
              <div style={styles.emptyState}>
                <span style={styles.emptyIcon}>📡</span>
                <h4 style={{ color: "#6e7687", marginBottom: 8 }}>Sin datos</h4>
                <p>Ingresa un Service ID y tu API Key para consultar.</p>
              </div>
            )}

            {data && (
              <div>
                {/* Cards de resumen */}
                <Card style={{ marginBottom: 20, borderRadius: 10, overflow: "hidden" }}>
                  <Card.Body style={{ padding: 0 }}>
                    <div style={{ display: "flex", flexWrap: "wrap" }}>
                      <div style={{ flex: "1 1 0", padding: "20px 24px", borderRight: "1px solid #e9ecef", textAlign: "center", minWidth: 140 }}>
                        <div style={styles.statLabel}>Service ID</div>
                        <div style={{ ...styles.statValue, marginTop: 4 }}>{data.service_id}</div>
                      </div>
                      {data.trackpoint && (
                        <div style={{ flex: "1 1 0", padding: "20px 24px", borderRight: "1px solid #e9ecef", textAlign: "center", minWidth: 140 }}>
                          <div style={styles.statLabel}>TrackPoint</div>
                          <div style={{ ...styles.statValue, wordBreak: "break-all", marginTop: 4 }}>
                            {data.trackpoint}
                          </div>
                        </div>
                      )}
                      {data.total_units != null && (
                        <div
                          onClick={() => this.setState({ showUnitsModal: true, unitSearch: "" })}
                          style={{ flex: "1 1 0", padding: "20px 24px", textAlign: "center", minWidth: 140, cursor: "pointer", transition: "background 0.2s" }}
                          onMouseEnter={(e) => e.currentTarget.style.background = "#f1f5f9"}
                          onMouseLeave={(e) => e.currentTarget.style.background = "transparent"}
                        >
                          <div style={styles.statLabel}>Unidades Retransmitidas</div>
                          <div style={{ ...styles.statValue, color: "#5eba00", fontSize: "1.6rem", marginTop: 4 }}>
                            {data.total_units}
                          </div>
                          <div style={{ fontSize: "0.7rem", color: "#9aa0ac", marginTop: 2 }}>
                            Click para ver detalle
                          </div>
                        </div>
                      )}
                    </div>
                  </Card.Body>
                </Card>

                {/* Buscar unidad específica */}
                {String(data.service_id) !== "186" && data.success && (
                <Card style={{ ...styles.searchCard, borderLeft: "4px solid #5eba00", marginBottom: 20 }}>
                  <Card.Body style={{ padding: "12px 20px" }}>
                    <Grid.Row alignItems="center">
                      <Grid.Col sm={8}>
                        <Form.Input
                          icon="truck"
                          value={user}
                          onChange={(e) => this.setState({ user: e.target.value })}
                          onKeyDown={this.handleKeyDown}
                          placeholder="Buscar unidad específica (ej: KV4162A)"
                        />
                      </Grid.Col>
                      <Grid.Col sm={4}>
                        <Button color="success" icon="search" onClick={this.fetchData} disabled={loading} block>
                          {loading ? "Buscando..." : user ? "Buscar Unidad" : "Ver Último General"}
                        </Button>
                      </Grid.Col>
                    </Grid.Row>
                  </Card.Body>
                </Card>
                )}

                {/* Modal de unidades */}
                <Modal
                  isOpen={this.state.showUnitsModal}
                  onRequestClose={() => this.setState({ showUnitsModal: false })}
                  ariaHideApp={false}
                  style={{
                    overlay: { backgroundColor: "rgba(0,0,0,0.6)", zIndex: 9999 },
                    content: {
                      top: "50%", left: "50%", right: "auto", bottom: "auto",
                      transform: "translate(-50%, -50%)",
                      width: "90%", maxWidth: 800, maxHeight: "85vh",
                      borderRadius: 10, padding: 0, overflow: "hidden",
                    },
                  }}
                >
                  <div style={{ padding: "16px 24px", borderBottom: "1px solid #e9ecef", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <h5 style={{ margin: 0 }}>
                      <Icon name="truck" style={{ marginRight: 12 }} />
                      Unidades Retransmitidas ({data ? data.total_units : 0})
                    </h5>
                    <button
                      onClick={() => this.setState({ showUnitsModal: false })}
                      style={{ background: "none", border: "none", fontSize: "1.2rem", cursor: "pointer", color: "#9aa0ac" }}
                    >✕</button>
                  </div>
                  <div style={{ padding: "12px 24px", borderBottom: "1px solid #e9ecef" }}>
                    <Form.Input
                      icon="search"
                      placeholder="Buscar por placa, IMEI o nombre..."
                      value={this.state.unitSearch}
                      onChange={(e) => this.setState({ unitSearch: e.target.value })}
                    />
                  </div>
                  <div style={{ overflowY: "auto", maxHeight: "calc(85vh - 130px)", padding: "0 12px" }}>
                    {data && data.units && (() => {
                      const q = this.state.unitSearch.toLowerCase();
                      const filtered = q
                        ? data.units.filter((u) =>
                            (u.username || "").toLowerCase().includes(q) ||
                            (u.imei || "").toLowerCase().includes(q) ||
                            (u.name || "").toLowerCase().includes(q)
                          )
                        : data.units;
                      return filtered.length > 0 ? (
                        <Table className="table-vcenter table-striped table-hover" responsive>
                          <Table.Header>
                            <Table.Row>
                              <Table.ColHeader style={{ width: 50 }}>#</Table.ColHeader>
                              <Table.ColHeader>Placa</Table.ColHeader>
                              <Table.ColHeader>Nombre</Table.ColHeader>
                              <Table.ColHeader>IMEI</Table.ColHeader>
                            </Table.Row>
                          </Table.Header>
                          <Table.Body>
                            {filtered.map((unit, j) => (
                              <Table.Row key={j}>
                                <Table.Col className="text-muted">{j + 1}</Table.Col>
                                <Table.Col><strong>{unit.username || "—"}</strong></Table.Col>
                                <Table.Col>{unit.name || "—"}</Table.Col>
                                <Table.Col><code style={{ fontSize: "0.82rem" }}>{unit.imei || "—"}</code></Table.Col>
                              </Table.Row>
                            ))}
                          </Table.Body>
                        </Table>
                      ) : (
                        <div style={{ padding: 32, textAlign: "center", color: "#9aa0ac" }}>
                          Sin resultados para "{this.state.unitSearch}"
                        </div>
                      );
                    })()}
                  </div>
                </Modal>

                {/* Detalle de retransmisión (solo para servicios != 186) */}
                {String(data.service_id) !== "186" && data.data && data.data.length > 0 && (() => {
                  const item = data.data[0];
                  return (
                    <div>
                      <Card style={{ marginBottom: 16 }}>
                        <Card.Header>
                          <Card.Title>
                            <Icon name="activity" style={{ marginRight: 10 }} />
                            Detalle de Retransmisión
                          </Card.Title>
                        </Card.Header>
                        <Card.Body>
                          {/* Timestamps */}
                          <Grid.Row style={{ marginBottom: 16 }}>
                            <Grid.Col sm={6}>
                              <div style={styles.statLabel}>Hora de Envío</div>
                              <div style={{ fontWeight: 600 }}>{item.event_time || "—"}</div>
                            </Grid.Col>
                            <Grid.Col sm={6}>
                              <div style={styles.statLabel}>Tiempo de Posición Reportada</div>
                              <div style={{ fontWeight: 600 }}>{item.pos_time || "—"}</div>
                            </Grid.Col>
                          </Grid.Row>

                          {/* Error */}
                          {item.syserrormsg && (
                            <div style={{ marginBottom: 16 }}>
                              <Alert type="danger" icon="alert-triangle">{item.syserrormsg}</Alert>
                            </div>
                          )}

                          {/* Respuesta */}
                          <div style={{ marginBottom: 16 }}>
                            <div style={{ ...styles.statLabel, marginBottom: 8 }}>Respuesta</div>
                            <pre style={styles.jsonPre}>{this.formatContent(item.response_pos)}</pre>
                          </div>

                          {/* Botón ver request */}
                          <Button
                            color="secondary"
                            icon="eye"
                            size="sm"
                            onClick={() => this.setState({ showRequestPos: true })}
                          >
                            Ver Request Enviado
                          </Button>
                        </Card.Body>
                      </Card>

                      {/* Modal Request POS */}
                      <Modal
                        isOpen={this.state.showRequestPos}
                        onRequestClose={() => this.setState({ showRequestPos: false })}
                        ariaHideApp={false}
                        style={{
                          overlay: { backgroundColor: "rgba(0,0,0,0.6)", zIndex: 9999 },
                          content: {
                            top: "50%", left: "50%", right: "auto", bottom: "auto",
                            transform: "translate(-50%, -50%)",
                            width: "90%", maxWidth: 800, maxHeight: "85vh",
                            borderRadius: 10, padding: 0, overflow: "hidden",
                          },
                        }}
                      >
                        <div style={{ padding: "16px 24px", borderBottom: "1px solid #e9ecef", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                          <h5 style={{ margin: 0 }}>
                            <Icon name="send" style={{ marginRight: 12 }} />
                            Request Enviado
                          </h5>
                          <button
                            onClick={() => this.setState({ showRequestPos: false })}
                            style={{ background: "none", border: "none", fontSize: "1.2rem", cursor: "pointer", color: "#9aa0ac" }}
                          >✕</button>
                        </div>
                        <div style={{ overflowY: "auto", maxHeight: "calc(85vh - 60px)", padding: 0 }}>
                          <pre style={{ ...styles.jsonPre, borderRadius: 0, border: "none" }}>{this.formatContent(item.request_pos)}</pre>
                        </div>
                      </Modal>
                    </div>
                  );
                })()}

                {/* JSON completo (solo para 186) */}
                {String(data.service_id) === "186" && (
                <Card>
                  <Card.Header>
                    <Card.Title>
                      <Icon name="code" style={{ marginRight: 8 }} />
                      Respuesta Completa (JSON)
                    </Card.Title>
                  </Card.Header>
                  <Card.Body style={{ padding: 0 }}>
                    <pre style={styles.jsonPre}>
                      {data.data && data.data.length > 0
                        ? (() => {
                            try {
                              const parsed = JSON.parse(data.data[0].response_pos);
                              return JSON.stringify(parsed, null, 2);
                            } catch(e) {
                              return data.data[0].response_pos;
                            }
                          })()
                        : JSON.stringify(data, null, 2)
                      }
                    </pre>
                  </Card.Body>
                </Card>
                )}
              </div>
            )}
          </Dimmer>
        </Page.Content>
      </SiteWrapper>
    );
  }
}

export default RetransmisionResponsePage;
